export const INITIAL_TABLO_DATA = {
    salary: {
        payTotal: 0,
        payBasedOnSkills: 0,
    },
    skillComparison: {
        percent: 0,
    },
    vacancies: {
        count: 0,
        link: '',
    },
};

export const DEBOUNCE_DELAY_MS = 500;
